import React, { useEffect, useState } from "react";
import { getFetcher, putFetcher } from "../../../../services/api";
import { useNavigate, useParams } from "react-router-dom";
import useSWR from "swr";
import { useForm } from "react-hook-form";
import { isResponseErrorObject } from "../../../../services/helpers";
import toast from "react-hot-toast";
import ControlledReactSelect from "../../../../components/elements/ControlledReactSelect";
import { Button, Card, CardBody, CardHeader, Input, Spinner, Switch } from "@nextui-org/react";
import RootAdmin from "../../../../components/layouts/RootAdmin";
import HeaderPage from "../../../../components/elements/HeaderPage";
import { month } from "../../../../services/enum";
import { yupResolver } from "@hookform/resolvers/yup";
import { reportVehicleValidation } from "../../../../services/validation";
import TransportComponent from "../../../../components/fragments/admin/report/transport/TransportComponent";

export const groupDataByPerusahaanAsalMuatId = (pengangkutanDetails) => {
  const groupedData = {};

  pengangkutanDetails[0].DataPerusahaanTujuanBongkarOnPengakutanDetail.forEach((item) => {
    const perusahaanAsalMuatId = item.perusahaanAsalMuatId;

    if (!groupedData[perusahaanAsalMuatId]) {
      groupedData[perusahaanAsalMuatId] = {
        perusahaanAsalMuat: item.perusahaanAsalMuat,
        perusahaanTujuanBongkar: [],
      };
    }

    groupedData[perusahaanAsalMuatId].perusahaanTujuanBongkar.push({
      ...item.perusahaanTujuanBongkar,
      jumlahDiAngkut: item.jumlahDiAngkut,
      jumlahDiBongkar: item.jumlahDiBongkar,
      locationTypeTujuan: item.locationTypeTujuan,
      longitudeTujuan: item.longitudeTujuan,
      latitudeTujuan: item.latitudeTujuan,
    });
  });

  return Object.values(groupedData || {});
};

export default function VehicleEditPage() {
  const { id, detailId } = useParams();
  const [filteredData, setFilteredData] = useState(null);
  const [fixedData, setFixedData] = useState(null);

  const navigate = useNavigate();
  const { data, isLoading } = useSWR(`/api/pelaporan-pengangkutan/find/${detailId}`, getFetcher);
  const {
    handleSubmit,
    setValue,
    reset,
    control,
    formState: { errors, isSubmitting },
  } = useForm({ resolver: yupResolver(reportVehicleValidation) });
  /* Disable agar bisa pilih B3 apa saja
  const { data: dataMaterial, isLoading: isLoadingMaterial } = useSWR(!isLoading && data ? `/api/vehicles/${data?.vehicleId}` : null, getFetcher);
  */
  const { data: dataMaterial, isLoading: isLoadingMaterial } = useSWR(!isLoading && data ? `/api/data-master/bahan-b3?returnAll=true` : null, getFetcher);

  useEffect(() => {
    if (!isLoading && data) {
      const fD = data?.pengangkutanDetails?.filter((item) => item.id === id);
      const gD = groupDataByPerusahaanAsalMuatId(fD);
      setFixedData(gD);
      setFilteredData(fD);
    }
  }, [isLoading, data, id, reset]);

  console.log(filteredData);

  useEffect(() => {
    if (fixedData !== null) {
      reset({
        b3SubstanceId: filteredData[0].dataBahanB3Id,
        perusahaanAsalMuatDanTujuanBongkar: fixedData?.map((item) => ({
          perusahaanAsalMuat: {
            perusahaanAsalMuatId: item.perusahaanAsalMuat.id,
            locationType: item.perusahaanAsalMuat.locationType,
            longitudeAsalMuat: item.perusahaanAsalMuat.longitude,
            latitudeAsalMuat: item.perusahaanAsalMuat.latitude,
          },
          perusahaanTujuanBongkar: item.perusahaanTujuanBongkar.map((item) => ({
            perusahaanTujuanBongkarId: item.perusahaanTujuanBongkarId || item.id,
            locationType: item.locationType,
            longitudeTujuanBongkar: item.longitude,
            latitudeTujuanBokar: item.latitude,
            jumlahDiAngkut: item.jumlahDiAngkut,
            jumlahDiBongkar: item.jumlahDiBongkar,
          })),
        })),
      });
    }
  }, [fixedData, filteredData, reset]);

  async function onSubmitForm(formData) {
    try {
      const payload = {
        b3SubstanceId: filteredData[0].b3SubstanceId,
        jumlahB3: formData.jumlahB3,
        perusahaanTujuanBongkar: formData?.perusahaanAsalMuatDanTujuanBongkar?.map((item) => ({
          perusahaanAsalMuatId: item.perusahaanAsalMuat.perusahaanAsalMuatId,
          locationType: item.perusahaanAsalMuat.locationType,
          longitudeAsalMuat: item.perusahaanAsalMuat.longitudeAsalMuat,
          latitudeAsalMuat: item.perusahaanAsalMuat.latitudeAsalMuat,
          perusahaanTujuanBongkar: item.perusahaanTujuanBongkar?.map((item) => ({
            perusahaanTujuanBongkarId: item.perusahaanTujuanBongkarId,
            locationType: item.locationType,
            longitudeTujuanBongkar: item.longitudeTujuanBongkar,
            latitudeTujuanBokar: item.latitudeTujuanBokar,
            jumlaBahanB3DiAngkut: parseInt(item.jumlahDiAngkut),
            jumlaBahanB3DiBongkar: parseInt(item.jumlahDiBongkar),
          })),
        })),
      };

      await putFetcher(`/api/pelaporan-pengangkutan/update/pengakutan-detail`, filteredData[0]?.id, payload);
      toast.success("Laporan pengangkutan berhasil diubah");
    } catch (error) {
      console.log(error);

      isResponseErrorObject(error.response.data.message)
        ? Object.entries(error.response.data.message).forEach(([key, value]) => {
            toast.error(value);
          })
        : toast.error(error.response.data.message);
    }
  }

  return (
    <RootAdmin>
      <HeaderPage title={`${data?.vehicle?.modelKendaraan} / ${data?.vehicle?.noPolisi}`} subtitle={"Ubah Riwayat Pengangkutan"} />
      <Card radius="sm" className="mt-3">
        <CardHeader></CardHeader>
        <CardBody>
          <form onSubmit={handleSubmit(onSubmitForm)} className="grid grid-cols-1 md:grid-cols-3 gap-3">
            {isLoading ? (
              <div>
                <Spinner />
              </div>
            ) : fixedData && fixedData.length > 0 ? (
              <>
                <Input label="Periode" labelPlacement="outside" isRequired isDisabled value={data?.period.name} />
                <Input label="Bulan" labelPlacement="outside" isRequired isDisabled value={month[data?.bulan - 1]} />
                <Input label="Tahun" labelPlacement="outside" isRequired isDisabled value={data?.tahun} />
                <div className="col-span-2">
                  <ControlledReactSelect
                  /*
                    options={dataMaterial?.BahanB3Kendaraan?.map((item) => ({
                      value: item.dataBahanB3Id,
                      label: `${item.dataBahanB3.casNumber} - ${item.dataBahanB3.namaBahanKimia}`,
                    }))}
                  */
                    options={dataMaterial?.data?.map((item) => ({ value: item.id, label: `${item.casNumber} - ${item.namaBahanKimia}` }))}
                    control={control}
                    isLoading={isLoadingMaterial}
                    label="Bahan B3"
                    name="b3SubstanceId"
                    isDisabled={true}
                  />
                </div>
                {!isLoading && filteredData !== null ? (
                  <div className="col-span-3">
                    <TransportComponent companyId={data?.companyId} control={control} setValue={setValue} errors={errors} />
                  </div>
                ) : (
                  <div className="col-span-3">
                    <Spinner />
                  </div>
                )}

                <div className="mt-3 space-x-2">
                  <Button isDisabled={isSubmitting} isLoading={isSubmitting} color="primary" type="submit">
                    Simpan
                  </Button>
                  <Button onPress={() => navigate(-1)} color="warning" variant="flat">
                    Kembali
                  </Button>
                </div>
              </>
            ) : (
              <p>Loading transport details...</p> // Optional: placeholder content while data loads
            )}
          </form>
        </CardBody>
      </Card>
    </RootAdmin>
  );
}
